import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ContributingCommitteeItem {
  CommitteeId: string; // Adjust the type as needed
  canComment?: boolean;
  mustVote?: boolean;
  canVote?: boolean;
}
interface CreateAdministrativeData {
  id: string;
  activeStep: number;
  contributingCommittee: ContributingCommitteeItem[];
}
const initialState: CreateAdministrativeData = {
  id: "",
  activeStep: 0,
  contributingCommittee: [],
};

const recordAdministrativeSlice = createSlice({
  name: "Administrative",
  initialState,
  reducers: {
    setAdministrativeRecordId: (state, action: PayloadAction<string>) => {
      state.id = action.payload; // Update the id in the state
    },
    setActiveStep: (state, action: PayloadAction<number>) => {
      state.activeStep = action.payload; // Update the id in the state
    },

    setContributionCommitteeId: (
      state,
      action: PayloadAction<ContributingCommitteeItem[]>
    ) => {
      state.contributingCommittee = action.payload; // Update the contributionCommitteeId
    },

    reset: () => initialState,
  },
});

export const {
  setAdministrativeRecordId,
  setActiveStep,
  setContributionCommitteeId,
  reset,
} = recordAdministrativeSlice.actions;
export default recordAdministrativeSlice.reducer;
